import React from 'react'
import Appointment from '../../Components/Patient/Appointment/Appointment'

const PatientAppointmentPage = () => {
  return (
    <div className='p-5 overflow-hidden'>
      <Appointment />
    </div>
  )
}

export default PatientAppointmentPage
